import React from 'react';
import { useTranslation } from 'react-i18next';
import './AboutSection.css';

const AboutSection = () => {
  const { t } = useTranslation();

  return (
    <section id="about" className="about-section section">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="about-title fade-in-up">
              {t('about.title')}
            </h2>
            <p className="about-description fade-in-up">
              {t('about.description')}
            </p>
            
            <div className="about-stats fade-in-up">
              <div className="stat-item">
                <div className="stat-number">50+</div>
                <div className="stat-label">资深专家</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">100K+</div>
                <div className="stat-label">活跃用户</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">$1B+</div>
                <div className="stat-label">管理资产</div>
              </div>
            </div>
          </div>
          
          <div className="about-visual">
            <div className="ocean-visual">
              <div className="wave-group">
                <div className="wave wave-1"></div>
                <div className="wave wave-2"></div>
                <div className="wave wave-3"></div>
              </div>
              <div className="floating-elements">
                <div className="element element-1">🌊</div>
                <div className="element element-2">⚓</div>
                <div className="element element-3">🚢</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection; 